import { z } from 'zod';

import { request } from '@/lib/api';
import { applyContent, sanitize, storeContent } from '@/lib/content-overrides';

const bundleSchema = z.record(z.string(), z.record(z.string(), z.string()));

/**
 * טוען מהשרת את הטקסטים שנערכו בקונסולה ומחיל אותם. נקרא בעליית האתר ואחרי
 * כל עריכה בקונסולה. כשל (שרת לא זמין) — נשארים עם מה שיש: הטקסט שבקוד, או
 * העותק האחרון מהדפדפן.
 */
export async function refreshContent(locale: string): Promise<void> {
  try {
    const bundle = sanitize(
      await request(`/public/content?locale=${encodeURIComponent(locale)}`, {
        schema: bundleSchema,
        tenant: null,
        // השרת מגיש את החבילה עם max-age=60; בלי זה עריכה או שחזור נראים כאילו לא נשמרו.
        cache: 'no-cache',
      }),
    );
    storeContent(locale, bundle);
    applyContent(locale, bundle);
  } catch {
    /* לא קריטי — הטקסטים המקוריים ממשיכים לעבוד */
  }
}
